import React from 'react';
import { Clock, Target } from 'lucide-react';
import { TalkingPoint } from '../data/webinarContent';
interface TalkingPointsProps {
  talkingPoint: TalkingPoint;
}
export function TalkingPoints({
  talkingPoint
}: TalkingPointsProps) {
  return <div className="space-y-6" data-id="element-230">
      {/* Timing */}
      <div className="flex items-center gap-2 text-[#0FB07D]" data-id="element-231">
        <Clock size={16} data-id="element-232" />
        <span className="text-sm font-medium" data-id="element-233">{talkingPoint.timing}</span>
      </div>

      {/* Key Messages */}
      <div data-id="element-234">
        <div className="flex items-center gap-2 mb-3" data-id="element-235">
          <Target size={16} className="text-[#0FB07D]" data-id="element-236" />
          <h4 className="text-[#F5F5F5] font-semibold text-sm" data-id="element-237">Key Messages</h4>
        </div>
        <ul className="space-y-2" data-id="element-238">
          {talkingPoint.keyMessages.map((message, index) => <li key={index} className="text-[#4D4D4D] text-sm pl-4 border-l-2 border-[#017C6D]" data-id="element-239">
              {message}
            </li>)}
        </ul>
      </div>

      {/* Talking Points */}
      <div data-id="element-240">
        <h4 className="text-[#F5F5F5] font-semibold text-sm mb-3" data-id="element-241">Script</h4>
        <div className="space-y-3" data-id="element-242">
          {talkingPoint.points.map((point, index) => <p key={index} className="text-[#F5F5F5] text-sm leading-relaxed" data-id="element-243">
              {point}
            </p>)}
        </div>
      </div>
    </div>;
}
export default TalkingPoints;